<template>
  <form id="customerInfo">
    <div class="tab">
      <input class="tab-input" id="form-header" type="checkbox" name="tabs" />
      <label class="tab-label" for="form-header">Persönliche Daten</label>
      <div class="tab-content" style="background-color: #f6f6f6; padding:0em 1em;">
        <div style="font-weight: 350; font-size: 12px;padding: 2em 0em;">
          <b>Datenschutzhinweis</b>: die von Ihnen eingegebenen Daten werden
          <b>nicht</b>
          an den Server übertragen. Das PDF-Dokument wird lokal bei Ihnen im
          Browser
          erzeugt,
          es werden keinerlei Daten versendet oder gespeichert!
        </div>

        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <label class="label" for="customerName">Name / Unternehmen</label>
              <div class="control">
                <input class="input" v-model="personInfo.name" type="text" name="customerName" placeholder="Name" />
              </div>
            </div>

            <div class="field">
              <label class="label" for="customerPhone">Telefon-Nr.</label>
              <div class="control">
                <input class="input" v-model="personInfo.phone" name="customerPhone" type="tel" placeholder="Telefon-Nummer" />
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <label class="label" for="customerStreet">Straße</label>
              <div class="control">
                <input class="input" v-model="personInfo.street" name="customerStreet" type="text" placeholder="Straße" />
              </div>
            </div>

            <div class="field">
              <label class="label" for="customerStreetNumber">Hausnummer</label>
              <div class="control">
                <input
                v-model="personInfo.streetNumber"
                  class="input"
                  name="customerStreetNumber"
                  type="text"
                  placeholder="Hausnummer"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <label class="label" for="customerZipCode">Postleitzahl</label>
              <div class="control">
                <input class="input" v-model="personInfo.zipcode" type="text" name="customerZipCode" placeholder="Postleitzahl" />
              </div>
            </div>

            <div class="field">
              <label class="label" for="customerPlace">Ort</label>
              <div class="control">
                <input class="input" v-model="personInfo.city" type="text" name="customerPlace" placeholder="Ort" />
              </div>
            </div>
          </div>
        </div>

        <div class="field" style="padding-bottom: 1em;">
          <label class="label" for="customerTaxId">Steuernummer</label>
          <div class="control">
            <input class="input" v-model="personInfo.taxId" type="text" name="customerTaxId" placeholder="Ihre Steuernummer" />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "timber-info-form",
  props: {
    personInfo: {
      name: String,
      phone: String,
      street: String,
      streetNumber: String,
      zipcode: String,
      city: String,
      taxId: String
    }
  }
};
</script>

<style scoped>
</style>